import React, { FC, useEffect } from 'react'
import { useTheme } from '@mui/material/styles'
import { useSelector } from 'react-redux'

import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Container from '@mui/material/Container'
import Divider from '@mui/material/Divider'

import nestedProperty from 'nested-property'

import Link from '../components/widgets/Link'
import FAIcon from '../components/widgets/FAIcon'

import projectSelectors from '../store/selectors/project'

import {
  v2CoversProject,
} from '../utils/v2'

import {
  MenuItem,
} from '../types/app'

import {
  FC_DASHBOARD_ICON_SIZE,
  BUTTON_VARIANT_OUTLINED,
} from '@kaidam/fc-shared/src/constants/mui'

const Dashboard: FC<React.PropsWithChildren<unknown>> = ({

}) => {
  const theme = useTheme()

  const project = useSelector(projectSelectors.currentProject)
  const menu = useSelector(projectSelectors.dashboardMenu)
  const externalLinks = useSelector(projectSelectors.externalLinksMenu)

  // Login, project and org switching, impersonation and every role bounce
  // land on this route, so forwarding here makes v2 the home page for them
  // all. replace() keeps /dashboard out of the history, so Back does not loop.
  const forwardToV2 = project ? v2CoversProject(project) : false
  useEffect(() => {
    if(!forwardToV2 || !project) return
    window.location.replace(`/v2/?project=${ project.id }`)
  }, [ forwardToV2, project?.id ])

  if(!project || forwardToV2) return null

  return (
    <Container
      maxWidth="md"
      sx={{
        p: 1,
        mt:0,
      }}
    >
      <Box
        sx={{
          py: 2,
          px: 1,
        }}
      >
        <Typography
          color="primary"
          align="left"
          gutterBottom
          variant="h2"
          sx={{
            mt: 2,
            mb: 6,
          }}
        >
          { project && project.meta && project.meta.title ? nestedProperty.get(project, 'meta.title') : '' }
        </Typography>
        <Grid
          container
          spacing={ 2 }
          rowGap={ 1 }
          justifyContent="center"
          alignItems="flex-start"
        >
          {
            menu.map((item: MenuItem, i) => {
              return (
                <Grid key={ i } item xs={ 6 } sm={ 4 } md={ 3 } lg={ 2 } sx={{
                  minHeight: '180px',
                  height: '180px'
                }}>
                  <Box
                    sx={{
                      height: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'flex-start',
                    }}
                  >
                    <Box
                      component={ Link }
                      sx={{
                        width: '100%',
                        textDecoration: 'none',
                        textAlign: 'center',
                        border: '1px solid',
                        borderColor: 'primary.main',
                        borderRadius: '10px',
                        backgroundColor: 'background.paper',
                      }}
                      name={ item.link as string }
                      params={ item.params }
                    >
                      {
                        typeof(item.icon) == 'string' && (
                          <FAIcon
                            iconName={ item.icon }
                            buttonVariant={ BUTTON_VARIANT_OUTLINED }
                            fontSize={ FC_DASHBOARD_ICON_SIZE }
                            color={ theme.palette.primary.main }
                            iconSx={{
                              py: 2,
                              px: 3,
                            }}
                          />
                        )
                      }
                    </Box>
                        <Typography
                      variant="h6"
                      color={ theme.palette.primary.main }
                      textAlign="center"
                      sx={{
                        p: 1,
                      }}
                    >
                      { item.title }
                    </Typography>
                  </Box>
                </Grid>
              )
            })
          }
        </Grid>
      </Box>

      { externalLinks && externalLinks.length > 0 &&
        <Box
          sx={{
            p: 4,
          }}
        >
          <Divider
            sx={{
              my: 6,
            }}
          />
          <Typography
            color="primary"
            align="center"
            gutterBottom
            variant="h2"
            sx={{
              mb: 4,
            }}
          >
            Links
          </Typography>
          <Grid
            container
            spacing={ 2 }
            justifyContent="center"
            alignItems="center"
          >
            {
              externalLinks.map((item, i) => {
                return (
                  <Grid key={ i } item xs={ 6 } sm={ 4 } md={ 3 }>
                    <Box
                      sx={{
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-starts',
                        justifyContent: 'center',
                      }}
                    >
                      <Box component="a"
                        sx={{
                          height: '100%',
                          textDecoration: 'none',
                          color: theme.palette.primary.main,
                          textAlign: 'center',
                        }}
                        target="_blank"
                        href={ item.link }
                      >
                        <Typography variant='h4' color="primary" fontSize={24} textAlign="center">{ item.title }</Typography>
                      </Box>
                    </Box>
                  </Grid>
                )
              })
            }
          </Grid>
        </Box>
      }
    </Container>
  );
}

export default Dashboard